// extracted by mini-css-extract-plugin
export default {"wrapper":"ProjectClientSection_wrapper__oLy6j","text_section":"ProjectClientSection_text_section__koT4J","paragraph":"ProjectClientSection_paragraph__rcuk8"};